"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = exports.spacings = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var css_1 = require("@emotion/css");
exports.spacings = {
  none: 0,
  xs: "2px",
  small: "4px",
  "medium-small": "6px",
  medium: "8px",
  "medium-large": "12px",
  large: "16px",
  xl: "24px",
  "2xl": "32px",
  "3xl": "40px",
  "4xl": "48px",
  "5xl": "64px",
  "6xl": "80px"
};
var Box = function (_a) {
  var align = _a.align,
    area = _a.area,
    border = _a.border,
    children = _a.children,
    className = _a.className,
    refObject = _a.refObject,
    _b = _a.component,
    Component = _b === void 0 ? "div" : _b,
    _c = _a.direction,
    direction = _c === void 0 ? "column" : _c,
    expand = _a.expand,
    gap = _a.gap,
    justify = _a.justify,
    padding = _a.padding,
    paddingBottom = _a.paddingBottom,
    paddingLeft = _a.paddingLeft,
    paddingRight = _a.paddingRight,
    paddingTop = _a.paddingTop,
    _d = _a.inline,
    inline = _d === void 0 ? false : _d,
    wrap = _a.wrap,
    childFlex = _a.childFlex,
    childBasis = _a.childBasis,
    childGrow = _a.childGrow,
    childShrink = _a.childShrink,
    reverse = _a.reverse,
    spacing = _a.spacing,
    restProps = __rest(_a, ["align", "area", "border", "children", "className", "refObject", "component", "direction", "expand", "gap", "justify", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "inline", "wrap", "childFlex", "childBasis", "childGrow", "childShrink", "reverse", "spacing"]);
  var _direction = "".concat(direction, "-").concat(reverse ? "reverse" : "").replace(/[-]$/, "");
  var _spacing = spacing ? exports.spacings[spacing] : undefined;
  var boxClass = (0, css_1.css)({
    display: inline ? "inline-flex" : "flex",
    flexDirection: _direction,
    gridArea: area,
    border: border ? "1px solid var(--color-border-form-default)" : undefined,
    borderRadius: border ? "2px" : undefined,
    gap: gap ? exports.spacings[gap] : _spacing,
    padding: padding ? exports.spacings[padding] : _spacing,
    paddingBottom: paddingBottom ? exports.spacings[paddingBottom] : undefined,
    paddingLeft: paddingLeft ? exports.spacings[paddingLeft] : undefined,
    paddingRight: paddingRight ? exports.spacings[paddingRight] : undefined,
    paddingTop: paddingTop ? exports.spacings[paddingTop] : undefined,
    alignItems: align === null || align === void 0 ? void 0 : align.replace(/^(start|end)$/g, "flex-$1"),
    justifyContent: justify === null || justify === void 0 ? void 0 : justify.replace(/^(start|end)$/g, "flex-$1"),
    flex: expand ? 1 : undefined,
    flexWrap: makeWrap(wrap)
  });
  var childClass = (0, css_1.css)({
    "&>*": {
      flex: childFlex,
      flexShrink: childShrink ? 1 : undefined,
      flexGrow: childGrow ? 1 : undefined,
      flexBasis: childBasis
    }
  });
  return (0, jsx_runtime_1.jsx)(Component, __assign({
    ref: refObject
  }, restProps, {
    className: (0, css_1.cx)("vsx-box", className, boxClass, childClass)
  }, {
    children: children
  }));
};
exports.Box = Box;
var makeWrap = function (wrap) {
  if (wrap === true) return "wrap";
  if (wrap === false) return undefined;
  if (wrap === "reverse") return "wrap-reverse";
  return wrap;
};